/**
 * LocaleSelectWrapper — 언어 코드 + 국기 이모지 선택 드롭다운.
 * 외부 라이브러리 직접 import 금지 — SelectWrapper(Select.ts) 래퍼를 통해 사용.
 *
 * HTML 패턴:
 *   <select data-locale-select
 *           data-current="ko"
 *           data-locales='[{"code":"ko","label":"한국어","flag":"🇰🇷"},...]'
 *           data-enabled='["ko","en"]'>
 *   </select>
 *
 * - data-locales: 전체 카탈로그 (서버에서 JSON 직렬화)
 * - data-enabled:  활성화된 코드 배열 (비활성 항목은 disabled)
 * - data-current:  현재 선택값 (초기 selected)
 */

import { SelectWrapper } from "./SelectWrapper";

export interface LocaleItem {
    code: string;
    label: string;
    flag: string;
}

export class LocaleSelectWrapper {
    constructor(private readonly select: HTMLSelectElement) {}

    init(): this {
        this._populate();

        new SelectWrapper(this.select, {
            placeholder: "언어를 선택하세요",
            searchPlaceholder: "언어 검색...",
        }).init();

        return this;
    }

    private _populate(): void {
        const locales: LocaleItem[] = this._parse(
            this.select.dataset.locales ?? "[]"
        );
        const enabled: string[] = this._parse(
            this.select.dataset.enabled ?? "[]"
        );
        const current = this.select.dataset.current ?? "";

        // 기존 옵션 제거
        while (this.select.firstChild) {
            this.select.removeChild(this.select.firstChild);
        }

        locales.forEach((item) => {
            const isEnabled = enabled.includes(item.code);
            const opt = document.createElement("option");
            opt.value = item.code;
            opt.textContent = item.label;
            opt.dataset.sublabel = item.code;
            opt.dataset.flagIso = item.flag;
            opt.disabled = !isEnabled;
            if (item.code === current) opt.selected = true;
            this.select.appendChild(opt);
        });
    }

    private _parse<T>(json: string): T {
        try {
            return JSON.parse(json) as T;
        } catch {
            return (Array.isArray(json) ? [] : {}) as T;
        }
    }
}

export function initLocaleSelects(root: Element | Document = document): void {
    root
        .querySelectorAll<HTMLSelectElement>(
            "[data-locale-select]:not([data-locale-inited])"
        )
        .forEach((select) => {
            select.dataset.localeInited = "1";
            new LocaleSelectWrapper(select).init();
        });
}
